import { render, staticRenderFns } from "./EssayStatisticsCard.vue?vue&type=template&id=5fe98cc8&"
import script from "./EssayStatisticsCard.vue?vue&type=script&lang=js&"
export * from "./EssayStatisticsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports